<!--content orders-->
<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2">
			<h1 class="titolo-bertazzoni">CONFIRM ORDER</h1>
		</div>
		<div class="mx-auto col-12 col-md-10 mt-5">
			<div class="d-lg-flex">
				<div class="d-flex justify-content-between">
					<h6 class="mr-4 mb-0">Order date:</h6>
					<div class="form-group mb-0 w-100">
						<select class="minimal w-100 rounded-0 border-black" name="anno" [(ngModel)]="filtri.anno" (change)="updateOrders()">
							<option *ngFor="let anno of anni" [value]="anno">{{anno}}</option>
						</select>
					</div>
				</div>
				<div class="ml-lg-5 mt-3 mt-lg-0 d-flex">
					<h6 class="mb-0 mr-3">Orders to be confirmed:</h6>
					<div class="custom-control custom-checkbox">
						<input
							class="checkbox"
							type="checkbox"
							id="check-open"
							value=""
							name="filtroDaConfermare"
							[(ngModel)]="filtri.daConfermare"
							(change)="updateOrders()" />
					</div>
				</div>
				<div class="ml-lg-5 mt-3 mt-lg-0 d-flex">
					<div class="row no-gutters" style="width: 200px">
						<input
							class="form-bertazzoni white border-right-0 rounded-0"
							type="SEARCH"
							placeholder="SEARCH"
							id=""
							name="parola"
							[(ngModel)]="filtri.parola" />
						<div class="border-left-0 rounded-0 rounded-right form-bertazzoni-search" (click)="filtra()">
							<i class="icon-search font-16"></i>
						</div>
					</div>
				</div>
				<div class="mt-3 mt-lg-0 d-flex">
					<button type="button" class="btn btn-bertazzoni black rounded-0 px-4 " (click)="aggiornaListini(contentAs400)">
						Alignment ERP
					</button>
				</div>
			</div>

			<div *ngIf="this.ordini.length === 0 && this.filtri.daConfermare" class="text-center">
				<h5 class="mt-5">No orders to confirm</h5>
			</div>
			<div *ngIf="this.ordini.length === 0 && !this.filtri.daConfermare" class="text-center">
				<h5 class="mt-5">No orders confirmed</h5>
			</div>
			<div class="border border-black mt-4" *ngFor="let ordine of ordiniVisualizzati">
				<div class="bg-black text-white font-12 p-3 accordion-header">
					<div class="row">
						<div class="col-11">
							<div class="row">
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Order date:</span>
										{{ordine.dataRegistrazioneOrdine | date: 'dd/MM/yy HH:mm'}}
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Order Customer Portal:</span>
										{{ordine.id}}
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">ERP Number:</span>
										<span *ngIf="ordine.confermato">{{trovaNSimag(ordine)}}</span>
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-md-8">
									<p class="font-14">
										<span class="font-semibold">Address:</span>
										<span *ngIf="ordine.indirizzo">
											{{ordine.indirizzo.indirizzo}}, {{ordine.indirizzo.localita}} {{ordine.indirizzo.provincia}}, {{ordine.indirizzo.cap}}
										</span>
										<span *ngIf="!ordine.indirizzo">
											{{ordine.utente.cliente.indirizzo}}, {{ordine.utente.cliente.localita}} {{ordine.utente.cliente.provincia}},
											{{ordine.utente.cliente.cap}}
										</span>
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">User:</span>
										{{ordine.utente.username}}
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-md-8">
									<p class="font-14">
										<span class="font-semibold">Company name:</span>
										{{ordine.utente.cliente.ragioneSociale}}
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">ERP Client:</span>
										{{ordine.utente.cliente.codiceCliente}}
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Number of items:</span>
										{{ordine.quantita}}
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Total order:</span>
										{{ '' | valuta }} {{totaleOrdine(ordine) | currency:'':''}}
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Total on list:</span>
										{{ '' | valuta }} {{totaleOrdineAListino(ordine) | currency:'':''}}
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">Purchase Order:</span>
										{{ordine.rifOrdineCliente}}
									</p>
								</div>
								<div class="col-md-4" *ngIf="ordine.statoOrdine !== 'ATTESA_CONFERMA_AGENTE'">
									<p class="font-14 pointer" (click)="apriModalePriorita(ordine, contentPriorita)">
										<span class="font-semibold"><u>Set the order priority</u></span>
									</p>
								</div>
								<div class="col-md-4" *ngIf="ordine.statoOrdine !== 'ATTESA_CONFERMA_AGENTE'">
									<p class="font-14">
										<span class="font-semibold">{{getMessaggioPrioritario(ordine)}}</span>
									</p>
								</div>
								<!-- <div class="col-md-8" *ngIf="ordine.statoOrdine === 'ATTESA_CONFERMA_AGENTE'">
									<p class="font-14">
										<span class="font-semibold" style="color: yellow;">
											Ordine in attesa di approvazione da parte dell'agente {{ordine.utente.agente?.username}}
										</span>
									</p>
								</div> -->
							</div>
						</div>
						<div class="col-1 align-self-center">
							<button class="btn btn-block rounded-0 py-1 mt-0" (click)="ordine.feOpen = !ordine.feOpen" style="color: white;">
								<img [src]="ordine.feOpen ? 'assets/img/minus.svg' :  'assets/img/plus.svg'" class="action-icon mb-1 mr-2" loading="lazy" />
							</button>
						</div>
					</div>
				</div>
				<div class="p-3 corpo-accordion" *ngIf="ordine.feOpen">
					<div class="row align-items-center mb-4">
						<div class="col-6 col-md-4 mb-3" *ngFor="let item of ordine.prodottiCarrello">
							<p class="text-secondary font-16 mb-2">
								{{item.prodottoCommerciale.codiceCommerciale}}
								<span class="text-black font-semibold" *ngIf="item.prioritario">(Priority)</span>
							</p>
							<p class="font-12 mb-1">
								<span class="font-semibold">Unit price list:</span>
								{{ '' | valuta }} {{item.prodottoCommerciale?.listini[0]?.prezzoNetto | currency:'':''}}
							</p>
							<p class="font-12 mb-1">
								<span class="font-semibold">Unit price upon order:</span>
								{{ '' | valuta }} {{item.prezzoUnitarioOriginale | currency:'':''}}
							</p>
							<p class="font-12 mb-1" *ngIf="item.prezzoScontatoApprovato">
								<span class="font-semibold">Discounted price:</span>
								{{ '' | valuta }} {{item.prezzoScontatoApprovato | currency:'':''}}
							</p>
							<p class="font-12 mb-2">
								<span class="font-semibold">Amount:</span>
								{{item.quantita}}
							</p>
							<p class="mb-2">
								{{ '' | valuta }} {{(item.quantita * (item.prezzoScontatoApprovato || item.prezzoUnitarioOriginale)) | currency:'':''}}
							</p>
						</div>
					</div>

					<div class="row">
						<div class="col-6 text-center align-self-center">
							<p class="font-14">
								<span class="font-semibold mr-2">Requested delivery date:</span>
								{{ordine.dataConsegnaRichiesta | date: 'dd/MM/yy'}}
							</p>
						</div>
						<div class="col-6 text-center">
							<button
								*ngIf="!ordine.confermato"
								type="button"
								class="btn btn-bertazzoni black rounded-0 px-4 ml-3"
								(click)="editOrder(content, ordine)">
								Edit Order
							</button>
							<button
								type="button"
								class="btn btn-bertazzoni black rounded-0 px-4 ml-3"
								(click)="apriModaleCompany(ordine, contentConferma)"
								*ngIf="!ordine.confermato && ordine.statoOrdine !== 'ATTESA_CONFERMA_AGENTE'">
								Confirm Order
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #contentConferma let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="">Confirm Order</h5>
		<button type="button" class="close" aria-label="Close" (click)="modal.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<form #formCompany="ngForm">
			<div class="row">
				<div class="col-12">
					<label class="font-16 font-semibold mr-3" for="company">Select a company</label>
					<select
						class="minimal rounded-0 border-black w-100 mb-2"
						name="company"
						required
						[ngModel]="selectedOrder.utente.company.id"
						(ngModelChange)="selectedOrder.idCompany = $event">
						<option [ngValue]="null">SELECT</option>
						<option *ngFor="let company of listaCompany" [value]="company.id">{{company.descrizione}}</option>
					</select>
				</div>
				<div class="col-12 mt-2 d-flex mt-3">
					<button class="btn btn-bertazzoni white btn-block rounded-0 mt-0 w-25 ml-auto" (click)="modal.close()">CLOSE</button>
					<button
						class="btn btn-bertazzoni black btn-block rounded-0 mt-0 w-25 ml-3"
						[class.disabled]="formCompany.invalid"
						(click)="conferma(selectedOrder); modal.close()">
						CONFIRM
					</button>
				</div>
			</div>
		</form>
	</div>
</ng-template>

<ng-template #content let-modal>
	<div class="modal-header">
		<h3 class="modal-title" id="">Edit order</h3>
		<button type="button" class="close" aria-label="Close" (click)="closeModal()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<table datatable [dtOptions]="dtSettings" class="row-border hover">
			<thead>
				<tr>
					<th>Product Code</th>
					<th>Total Price</th>
					<th>Amount</th>
					<th>Unit price list</th>
					<th></th>
				</tr>
			</thead>
			<tbody *ngIf="selectedOrder.prodottiCarrello.length">
				<tr *ngFor="let product of selectedOrder.prodottiCarrello">
					<td>{{product.prodottoCommerciale.codiceCommerciale}}</td>
					<td>{{ '' | valuta }} {{(product.quantita * product.prezzoUnitarioOriginale) | currency:'':''}}</td>
					<td>
						<div class="row" *ngIf="product.feEdit">
							<input
								type="number"
								min="0"
								class="form-bertazzoni white rounded-0"
								placeholder="Quantità"
								[(ngModel)]="product.quantita"
								name="quantita" />
						</div>
						<div *ngIf="!product.feEdit">
							{{product.quantita}}
						</div>
					</td>
					<td>
						<div class="row ml-2" *ngIf="false">
							<input
								type="number"
								min="0"
								class="form-bertazzoni white rounded-0"
								placeholder="Prezzo unitario"
								[(ngModel)]="product.prezzoUnitarioOriginale"
								name="prezzo unitario" />
						</div>
						<div>{{ '' | valuta }} {{product.prezzoUnitarioOriginale | currency:'':''}}</div>
					</td>
					<th>
						<div class="d-flex pl-1">
							<button type="button" class="btn btn-bertazzoni black rounded-0" *ngIf="product.feEdit" (click)="saveProduct(product)">
								SAVE
							</button>
							<img src="assets/img/pencil.svg" class="action-icon" *ngIf="!product.feEdit" (click)="product.feEdit = !product.feEdit" />
							<img src="assets/img/delete.svg" class="action-icon ml-3" (click)="deleteProduct(product)" />
						</div>
					</th>
				</tr>
			</tbody>
		</table>

		<div class="row pt-5">
			<div class="col-md-4 add-product-container">
				<form class="no-gutters" #formAddProduct="ngForm">
					<p class="ont-16 mb-3">Add product</p>
					<input
						type="text"
						class="form-control mb-2 rounded-0 form-bertazzoni white"
						placeholder="PRODUCT NUMBER"
						[(ngModel)]="jsonInAddTocart.codiceCommerciale"
						name="codiceCommerciale"
						required />
					<div class="number-input mb-3">
						<div (click)="stepQuantitaGenerico('-')" class="selettore-spin"></div>
						<input
							class="quantity form-bertazzoni"
							min="0"
							max="100"
							name="quantity"
							value="1"
							type="number"
							[(ngModel)]="jsonInAddTocart.quantita"
							required />
						<div (click)="stepQuantitaGenerico('+')" class="selettore-spin plus"></div>
					</div>
					<p *ngIf="addProductErrorMessage" class="text-danger">{{addProductErrorMessage}}</p>
					<button
						type="button"
						class="btn btn-bertazzoni black btn-block rounded-0 py-2"
						(click)="addProduct(jsonInAddTocart.codiceCommerciale)"
						[disabled]="formAddProduct.invalid || jsonInAddTocart.quantita == 0">
						ADD
					</button>
				</form>
			</div>
			<div class="col-md-6 total-order-container">
				<div class="total-order-content">
					<h4>Total order in price list</h4>
					<h5>{{ '' | valuta }} {{totaleOrdineAListino(selectedOrder) | currency:'':''}}</h5>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 offset-md-6 text-right">
				<button type="button" class="btn btn-bertazzoni black rounded-0 px-4 ml-3" (click)="closeModal()">Close</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #contentAs400 let-modal>
	<div class="modal-header">
		<h3 class="modal-title" id="">Alignment with ERP started.</h3>
		<button type="button" class="close" aria-label="Close" (click)="closeModal()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<p>
			This may take 5 to 10 minutes.
			<br />
			You can continue to browse the portal freely.
		</p>
	</div>
</ng-template>

<ng-template #contentSageX3 let-modal>
	<div class="modal-header">
		<h3 class="modal-title" id="">Alignment with SageX3 started.</h3>
		<button type="button" class="close" aria-label="Close" (click)="closeModal()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<p>
			This may take 5 to 10 minutes.
			<br />
			You can continue to browse the portal freely.
		</p>
	</div>
</ng-template>

<ng-template #contentPriorita let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="">Set order priority</h5>
		<button type="button" class="close" aria-label="Close" (click)="modal.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<form #formMail="ngForm">
			<div class="row">
				<div class="col-12">
					<label class="font-16 font-semibold mr-3" for="prioritario">Prioritize the whole order</label>
					<input
						class="checkbox float-right mr-3"
						type="checkbox"
						id="prioritario"
						value=""
						name="prioritario"
						[(ngModel)]="selectedOrder.prioritario" />
				</div>
				<div class="col-12" *ngIf="!selectedOrder.prioritario">
					<div class="row" *ngFor="let item of selectedOrder.prodottiCarrello">
						<div class="col-12"><hr class="my-2" /></div>
						<div class="col-12">
							<label for="prioritario-{{item.id}}">{{item.prodottoCommerciale.codiceCommerciale}}</label>
							<input
								class="checkbox float-right mr-3"
								type="checkbox"
								id="prioritario-{{item.id}}"
								value=""
								name="prioritario-{{item.id}}"
								[(ngModel)]="item.prioritario" />
						</div>
					</div>
				</div>
				<div class="col-12 mt-2 d-flex mt-3">
					<button class="btn btn-bertazzoni white btn-block rounded-0 mt-0 w-25 ml-auto" (click)="modal.close()">CLOSE</button>
					<button
						class="btn btn-bertazzoni black btn-block rounded-0 mt-0 w-25 ml-3"
						[class.disabled]="formMail.invalid"
						[disabled]="formMail.invalid"
						(click)="savePriorita(modal)">
						SAVE
					</button>
				</div>
			</div>
		</form>
	</div>
</ng-template>
